module.exports = __webpack_public_path__ + "img/cooperative-partner1.1595b57f.png";